module.exports = __webpack_public_path__ + "static/media/schedule.11dbb9ed.svg";